import { DataType } from 'components/BasicTable/types';
import { BalanceRequest } from './balance.constants';
import { BankAccountRequest } from './bank-account.constants';
import { BeneficiaryRequest, Payment } from './beneficiary.constants';

export enum RequestsTabType {
	AwaitingAuth = 'AwaitingAuth',
	OpenPending = 'OpenPending',
}

export const RequsetPaymentTableColumn: { [key: string]: DataType } = {
	reference: 'link',
	createdAt: 'date',
	//dueDate: "date",
	amount: 'number',
	companyNickname: 'string',
	companyCountry: 'string',
	//status: "string",
	paymentType: 'string',
	//createdBy: 'string',
	//fee: "number",
};

export const RequestContactTableColumn: { [key: string]: DataType } = {
	reference: 'string',
	name: 'string',
};

export enum PendingRequestTypes {
	BANK_ACCOUNTS = 'bankAccountsRequests',
	BALANCES = 'balancesRequests',
	BENEFICIARIES = 'beneficiariesRequests',
	PAYMENTS = 'paymentRequests',
	CONTACTS = 'contactRequests',
  WITHDRAWAL = 'withdrawal'
}

export type requestData = {
	[PendingRequestTypes.BANK_ACCOUNTS]: { [key: string]: any }[];
	[PendingRequestTypes.BALANCES]: { [key: string]: any }[];
	[PendingRequestTypes.BENEFICIARIES]: { [key: string]: any }[];
	[PendingRequestTypes.PAYMENTS]: { [key: string]: any }[];
	[PendingRequestTypes.CONTACTS]: { [key: string]: any }[];
  [PendingRequestTypes.WITHDRAWAL]: { [key: string]: any }[];
};

export const initialRequestData: requestData = {
	[PendingRequestTypes.BANK_ACCOUNTS]: [],
	[PendingRequestTypes.BALANCES]: [],
	[PendingRequestTypes.BENEFICIARIES]: [],
	[PendingRequestTypes.PAYMENTS]: [],
	[PendingRequestTypes.CONTACTS]: [],
  [PendingRequestTypes.WITHDRAWAL]: [],
};
